import { isAfter, parseISO } from 'date-fns';

import { type GetDataIngestionSourcesResponse } from '../../../types';

/**
 * Filters datasets that have been updated after the batch was created.
 */
export const getNewerDatasets = <
  T extends GetDataIngestionSourcesResponse['sources'][number],
>(
  datasets: T[],
  batchCreatedAt?: string,
): T[] => {
  if (!batchCreatedAt) {
    return [];
  }

  return datasets.filter(({ updated_at }) =>
    isAfter(parseISO(updated_at), parseISO(batchCreatedAt)),
  );
};
